<div class="column">
    <h2>Rettocolite ulcerosa - Pazienti stabili e instabili per sesso</h2>
    <div style="display: inline-block" style = "padding-left: 3vw; padding-top: 0vw; position: center">
      <div class = "chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
        <canvas id = "myChartStableUnstableUCGender"></canvas>
      </div>
    </div>
  </div>